import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import {
  CardComponent,
  CardContentComponent,
} from '@gains-com/ui-angular';
import { PurchaseDialogHeaderComponent } from '../purchase-dialog-header/purchase-dialog-header.component.js';
import { IntercomClient } from '../../../../core/intercom-client.service.js';
import { EnvironmentPipe } from '../../../../pipes/environment.pipe.js';

export type PaymentsOfflineCause = 'sitewide' | 'user';

@Component({
  selector: 'app-payments-offline',
  imports: [
    CardComponent,
    CardContentComponent,
    PurchaseDialogHeaderComponent,
    EnvironmentPipe,
  ],
  templateUrl: './payments-offline.component.html',
  styleUrls: ['../styles.scss', './payments-offline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentsOfflineComponent {
  // Inject Intercom directly. Sibling sub-views (card-confirm-purchase,
  // crypto-confirm-purchase) emit `close.emit('contact-support')` instead, but
  // PurchasesDialogComponent doesn't actually forward that result to Intercom —
  // direct injection (matching auth.component.ts) is the working pattern.
  private readonly _intercom = inject(IntercomClient);

  cause = input.required<PaymentsOfflineCause>();
  /** When true, render a back arrow that emits `back`. */
  showBack = input<boolean>(false);
  readonly close = output<void>();
  readonly back = output<void>();

  openSupport() {
    this._intercom.open();
    this.close.emit();
  }
}
